export enum ApplicationTableColumns {
    Name = 'name',
    DisplayName = 'displayName',
    Type = 'type',
    Actions = 'actions',
}

export enum ApplicationTableButtons {
    Delete = 'delete',
    Information = 'information',
}
